import { getLayerIdentifier } from "@buildwithflux/models";
/**
 * Cache of chosen list of via configurations (string[]) for a given set of connected layers and enabled via configurations.
 * The cache is intended to be stored and used at runtime to avoid expensive computation while selecting the best via configs.
 * Most of the cache is populated inside a webworker during the baking phase.
 */
export class SmartViaConfigsCache {
    cache;
    copperLayers;
    constructor(cache, copperLayers) {
        this.cache = cache;
        this.copperLayers = copperLayers;
    }
    get(connectedLayers, enabledViaConfigs) {
        let configUids;
        if (Array.isArray(connectedLayers)) {
            const key = this.getKey(connectedLayers, enabledViaConfigs);
            configUids = this.cache[key];
        }
        else {
            configUids = this.cache[connectedLayers];
        }
        return configUids;
    }
    set(connectedLayers, enabledViaConfigs, value) {
        if (Array.isArray(connectedLayers)) {
            const key = this.getKey(connectedLayers, enabledViaConfigs);
            this.cache[key] = value;
        }
        else {
            this.cache[connectedLayers] = value;
        }
    }
    has(connectedLayers, enabledViaConfigs) {
        const key = this.getKey(connectedLayers, enabledViaConfigs);
        return key in this.cache && this.cache[key] !== undefined;
    }
    getKey(connectedLayers, enabledViaConfigs) {
        if (this.copperLayers && connectedLayers.includes("All")) {
            connectedLayers = this.copperLayers.map(getLayerIdentifier);
        }
        const sortedConnectedLayers = connectedLayers.slice().sort();
        const sortedEnabledViaConfigs = enabledViaConfigs.slice().sort();
        return `${sortedConnectedLayers.join(",")}-${sortedEnabledViaConfigs.join(",")}`;
    }
}
//# sourceMappingURL=SmartViaConfigsCache.js.map